// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1lZIc","mit-logo":"footer_mit-logo__Iv656","info":"footer_info__32CKn"};